import API from '../config/baseUrl';

export interface DeviceRegistrationResponse {
  success: boolean;
  data: {
    deviceId: string;
    message: string;
  };
}

export async function generateDeviceId(): Promise<string> {
  const storedDeviceId = localStorage.getItem('deviceId');
  if (storedDeviceId) {
    return storedDeviceId;
  }

  try {
    const response = await API.get<DeviceRegistrationResponse>('/api/v1/device-registration/initiateDeviceRegistration');
    
    if (response.data.success && response.data.data.deviceId) {
      return response.data.data.deviceId;
    } else {
      throw new Error('Invalid response from device registration API');
    }
  } catch (error: any) {
    console.error('Failed to get device ID from API:', error);
    
    if (error.response?.status === 400) {
      throw new Error('Device initiation failed');
    }
    
    throw new Error('Device initiation failed');
  }
}
